import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.less']
})
export class YesNoComponent implements OnInit {
  @Input() property : boolean;
  @Input() questionText : string;
  @Input() propertyName : string;
  @Output() propertyUpdated = new EventEmitter<any>();

  constructor() {

    console.log(this.property);
    console.log(this.questionText);
   }

  selected(val : boolean)
  {
    console.log(val);
    this.property = val;
    this.propertyUpdated.emit({name :this.propertyName, value:val});
  }
  
  ngOnInit() {
    console.log(this.property);
    console.log(this.questionText);
  }
}
